import { FC, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { HeaderMedicalInstitutionRegister } from 'components';
import MedicalRegisterFirstStep from './MedicalRegisterFirstStep';
import MedicalRegisterSecondStep from './MedicalRegisterSecondStep';
import MedicalRegisterThirdStep from './MedicalRegisterThirsStep';
import { resetState } from './slices';
import Wrap from './styles';

const MedicalInstitutionRegister: FC = () => {
  const dispatch = useDispatch();
  const [currentStep, setCurrentStep] = useState<number>(0);

  useEffect(() => {
    return () => {
      dispatch(resetState());
    };
  }, [dispatch]);

  const stepToPrevious = () => {
    setCurrentStep(currentStep - 1);
  };
  const nextStep = () => {
    currentStep < 3 && setCurrentStep(1 + currentStep);
  };

  const screen = () => {
    switch (currentStep) {
      case 0:
        return <MedicalRegisterFirstStep nextStep={nextStep} />;
      case 1:
        return <MedicalRegisterSecondStep nextStep={nextStep} stepToPrevious={stepToPrevious} />;
      case 2:
        return <MedicalRegisterThirdStep />;
    }
  };
  return (
    <Wrap>
      <HeaderMedicalInstitutionRegister nextStep={nextStep} currentStep={currentStep} />
      <div>{screen()}</div>
    </Wrap>
  );
};

export default MedicalInstitutionRegister;
